import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import axios from 'axios';
import { useAuth } from './AuthContext';
import API_BASE from '../utils/api';

const LicenseContext = createContext(null);
export const useLicense = () => useContext(LicenseContext);

export const LicenseProvider = ({ children }) => {
  const { user, isAuthenticated } = useAuth();
  const [enabledModules, setEnabledModules] = useState(null);

  useEffect(() => {
    if (!isAuthenticated) {
      setEnabledModules(null);
      return;
    }
    axios.get(`${API_BASE}/license/current`)
      .then(res => {
        if (res.data.modules) setEnabledModules(res.data.modules);
      })
      .catch(() => {});
  }, [isAuthenticated]);

  // Super admins and pre-load state (null = not loaded / no license restriction) always see everything
  const isModuleEnabled = useCallback((moduleKey) => {
    if (!moduleKey) return true;
    if (user?.role === 'super_admin') return true;
    if (enabledModules === null) return true;
    return enabledModules.includes(moduleKey);
  }, [user, enabledModules]);

  return (
    <LicenseContext.Provider value={{ enabledModules, isModuleEnabled }}>
      {children}
    </LicenseContext.Provider>
  );
};
